import React, { useEffect } from "react";

import { GLOBAL_MODALS } from "../config/modals";

import useStore from "../store";

const ModalContainer = ({ user, resume, isResumeUploadNotified }) => {

  const { visible, showModal, closeModal } = useStore(state => state.modal);

  // User is logged and has no resume and has not been notified about it yet,
  // show the resume upload modal.
  useEffect(() => {
    if (user?.uuid && !Boolean(resume) && !isResumeUploadNotified) {
      showModal("set-resume-modal");
    }
  }, []);

  if (visible !== null) {
    const Modal = GLOBAL_MODALS[visible];
    return <Modal user={user} onClose={closeModal} />;
  }

  return null;
}

export default ModalContainer;
